import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";

import Popover from "@material-ui/core/Popover";
import styled from "styled-components";

const styles = theme => ({
  h3: {
    textAlign: "center",
    paddingLeft: "1rem",
    paddingRight: "1rem"
  },
  p: {
    textAlign: "center",
    paddingLeft: "1rem",
    paddingRight: "1rem"
  },
  typography: {
    margin: theme.spacing.unit * 2
  }
});

const Column = styled.div(props => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  backgroundColor: props.color,
  textAlign: "right"
}));

class GeneralPopOver extends React.Component {
  state = {
    anchorEl: null
  };

  handleClick = event => {
    this.setState({
      anchorEl: event.currentTarget
    });
  };

  handleClose = () => {
    this.setState({
      anchorEl: null
    });
  };

  render() {
    const { classes, itemText, key } = this.props;
    const { anchorEl } = this.state;
    const open = Boolean(anchorEl);

    return (
      <Column key={`${key}_c`}>
        <this.props.iconImage
          aria-owns={open ? "simple-popper" : undefined}
          aria-haspopup="true"
          variant="contained"
          onClick={this.handleClick}
          style={{ color: "black", width: "20px" }}
        />
        <Popover
          id="simple-popper"
          key={`${key}_p`}
          open={open}
          anchorEl={anchorEl}
          onClose={this.handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center"
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center"
          }}
        >
          {/* <h5 className={classes.h3}>{itemText}</h5> */}
          <p className={classes.p}>{itemText}</p>
        </Popover>
      </Column>
    );
  }
}

GeneralPopOver.propTypes = {
  classes: PropTypes.object.isRequired,
  key: PropTypes.string
};

export default withStyles(styles)(GeneralPopOver);



// WEBPACK FOOTER //
// ./src/components/generalPopOver.js